module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day01_02_stay-017e2c620b888a0ad47f455a740f4865.jpg";